import { render, staticRenderFns } from "./ButtonViewLogTable.vue?vue&type=template&id=2a50a1df&scoped=true"
import script from "./ButtonViewLogTable.vue?vue&type=script&lang=js"
export * from "./ButtonViewLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50a1df",
  null
  
)

export default component.exports